import { ErrorProvider } from 'context/error/ErrorContext';
import { GalleryProvider } from 'context/gallery/GalleryContext';
import React from 'react';
import { AuthProvider } from './context/auth/AuthContext';
import { ModelProvider } from './context/model/ModelContext';
import Routes from './Routes';

const App: React.FC = () => {
    return (
        <ErrorProvider>
            <AuthProvider>
                <ModelProvider>
                    <GalleryProvider>
                        <Routes />
                    </GalleryProvider>
                </ModelProvider>
            </AuthProvider>
        </ErrorProvider>
    );
};

export default App;
